<template>
  <div>
    <div
      class="modal animated fadeIn purposeModal"
      tabindex="-1"
      id="rolesLoaderModal"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-sm" style="top: 40%">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-fluid">
              <div class="row">
                <div class="col-md-12">
                  <center>
                    <img src="static/assets/images/ajax-loader.gif" /> deleting,
                    please wait..
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="breadcrumb">
      <ul>
        <li><router-link to="/">Dashboard</router-link></li>
        <li>Manage role</li>
      </ul>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Manage role</div>
            <fieldset class="border p-3">
              <legend class="auto-wp">
                <small style="font-size: 15px; font-weight: bold"
                  >manage roles</small
                >
              </legend>

              <div></div>
              <div>
                <div class="rolesLoader">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i
                    class="fa fa-spinner fa-spin"
                    style="font-size: 24px; color: blue"
                  ></i>
                  loading roles...
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="systemRoles"
                  :fixed-header="true"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 6,
                    position: 'bottom',
                    perPageDropdown: [3, 7, 9],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'Action'">
                      <button
                        class="btn btn-raised btn-raised-info btn-sm m-1"
                        @click="viewRole(props.row.id)"
                      >
                        <i class="nav-icon i-Pen-2 font-weight-bold"></i>
                      </button>

                      <button
                        class="btn btn-raised btn-raised-danger btn-sm m-1"
                        @click="deleteRole(props.row.id)"
                      >
                        <i class="nav-icon i-Close-Window font-weight-bold"></i>
                      </button>
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      columns: [
        {
          label: "role Name",
          field: "role_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter role",
          },
        },
        {
          label: "role Slug",
          field: "role_slug",
          type: "text",
          filterable: true,
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true,
        },
      ],
    };
  },
  created() {
    this.loadRoles();
  },
  computed: {
    ...mapGetters(["systemRoles", "systemRole"]),
  },
  methods: {
    ...mapActions(["loadRoles", "viewRole", "deleteRole"]),
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/roles/manageroles.vue